function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import JSON2CSVBase from './BaseParser.js';
import { flattenReducer, fastJoin } from './utils.js';

var JSON2CSVParser = /*#__PURE__*/function (_JSON2CSVBase) {
  _inherits(JSON2CSVParser, _JSON2CSVBase);

  var _super = _createSuper(JSON2CSVParser);

  function JSON2CSVParser(opts) {
    _classCallCheck(this, JSON2CSVParser);

    return _super.call(this, opts);
  }
  /**
   * Main function that converts json to csv.
   *
   * @param {Array|Object} data Array of JSON objects to be converted to CSV
   * @returns {String} The CSV formated data as a string
   */


  _createClass(JSON2CSVParser, [{
    key: "parse",
    value: function parse(data) {
      var preprocessedData = this.preprocessData(data);
      this.opts.fields = this.opts.fields || this.preprocessFieldsInfo(preprocessedData.reduce(function (fields, item) {
        Object.keys(item).forEach(function (field) {
          if (!fields.includes(field)) {
            fields.push(field);
          }
        });
        return fields;
      }, []), this.opts.defaultValue);
      var header = this.opts.header ? this.getHeader() : '';
      var rows = this.processData(preprocessedData);
      var csv = (this.opts.withBOM ? "\uFEFF" : '') + header + (header && rows ? this.opts.eol : '') + rows;
      return csv;
    }
    /**
     * Preprocess the data according to the give opts (unwind, flatten, etc.)
      and calculate the fields and field names if they are not provided.
     *
     * @param {Array|Object} data Array or object to be converted to CSV
     */

  }, {
    key: "preprocessData",
    value: function preprocessData(data) {
      var _this = this;

      var processedData = Array.isArray(data) ? data : [data];

      if (!this.opts.fields) {
        if (data === undefined || data === null || processedData.length === 0) {
          throw new Error('Data should not be empty or the "fields" option should be included');
        }

        if (_typeof(processedData[0]) !== 'object') {
          throw new Error('Data items should be objects or the "fields" option should be included');
        }
      }

      if (this.opts.transforms.length === 0) return processedData;
      return processedData.map(function (row) {
        return _this.preprocessRow(row);
      }).reduce(flattenReducer, []);
    }
    /**
     * Create the content row by row below the header
     *
     * @param {Array} data Array of JSON objects to be converted to CSV
     * @returns {String} CSV string (body)
     */

  }, {
    key: "processData",
    value: function processData(data) {
      var _this2 = this;

      return fastJoin(data.map(function (row) {
        return _this2.processRow(row);
      }).filter(function (row) {
        return row;
      }), // Filter empty rows
      this.opts.eol);
    }
  }]);

  return JSON2CSVParser;
}(JSON2CSVBase);

export { JSON2CSVParser as default };